import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ResetarSenhaUsuarioMainframe } from './types';

export const INITIAL_STATE: ResetarSenhaUsuarioMainframe = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ResetarSenhaUsuarioMainframe {
	return produce(state, draft => {
		switch (action.type) {
			case Types.RESETAR_SENHA_USUARIO_MAINFRAME_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.RESETAR_SENHA_USUARIO_MAINFRAME_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.RESETAR_SENHA_USUARIO_MAINFRAME_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.RESETAR_SENHA_USUARIO_MAINFRAME_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
